type ConversionDetails = Record<string, string>
type AnalyticsWindow = Window & { dataLayer?: Array<Record<string, string>> }

export function trackConversion(event: string, details: ConversionDetails = {}) {
  const payload = { event, ...details }
  window.dispatchEvent(new CustomEvent('kima:conversion', { detail: payload }))
  const dataLayer = (window as AnalyticsWindow).dataLayer
  if (Array.isArray(dataLayer)) dataLayer.push(payload)
}
